export const devConfig = {
  environment: "DEVELOPMENT",
  isMobileApp: false,
  platform: "Web", // Web, Android, IOS

  debug: true,
  apiUrl: "https://devapi.evjoints.com/", // For prod Usage
  // apiUrl: "http://35.154.16.142:9000/", // For dev Usage
  // apiUrl: "http://127.0.0.1:4000", // For Developer's Local Usage
  legacyApiUrl: "http://35.154.154.159",

  
  toastTimeout: 4000,
  tokenKey: "token",
  legacyTokenKey: "legacyToken",
  vendor_id: "",
  name: "",
  email: "",
  mobile: "",
  status: "",
  pan: "",
  gst_no: "",
  area: "",
  business_type: "",
  business_email: "",
  business_mobile: "",
  companyName: "Ev",
  
  //used for website url
 

};
